/**
 * Reglas puras de la pantalla Simulador (tanda 3), probadas sin navegador.
 */
import { ZONA_DEL_NEGOCIO } from './zona';

/** Teléfono con el que arranca la pantalla: el rango de las pruebas a mano (0140 en adelante). */
export const TELEFONO_POR_DEFECTO = '809-555-0140';
/** Cuánto adelanta el reloj cada clic. */
export const PASO_DEL_RELOJ_H = 3;
/** La API no deja adelantar el reloj más de 20 h (simulador.routes: MAX_ADELANTO_DEL_RELOJ_MS). */
export const ADELANTO_MAXIMO_H = 18;
const HORA_MS = 3_600_000;
const ZONA = ZONA_DEL_NEGOCIO;

/** ¿Es un teléfono ficticio 809-555-xxxx? La misma regla que la API (telefonoSimulado). */
export function esTelefonoDeLaDemo(t: string): boolean {
  return /^1?809555\d{4}$/.test(t.replace(/\D/g, ''));
}

export function siguienteAdelanto(actualH: number): number {
  return Math.min(ADELANTO_MAXIMO_H, actualH + PASO_DEL_RELOJ_H);
}

/** La hora de la demo: la real más el adelanto. */
export function relojDeLaDemo(adelantoH: number, ahora: Date = new Date()): Date {
  return new Date(ahora.getTime() + adelantoH * HORA_MS);
}

/** La hora del negocio de un instante, corta y de 12 h («2:05 p. m.»), como la dicen los avisos. */
export function horaDelNegocio(d: Date): string {
  return new Intl.DateTimeFormat('es', { timeZone: ZONA, hour: 'numeric', minute: '2-digit', hour12: true }).format(d);
}

/** De 22:00 a 7:00 locales «sin respuesta» no avisa (canal-de-avisos: enHorarioDeAvisos). */
export function esDeNoche(d: Date): boolean {
  const h = Number(new Intl.DateTimeFormat('en-US', { timeZone: ZONA, hour: '2-digit', hourCycle: 'h23' }).format(d));
  return h < 7 || h >= 22;
}
